import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "flex flex-row justify-end h-6" }
const _hoisted_3 = {
  key: 0,
  class: "px-4 pt-1 bg-teal-500 text-white text-sm rounded-t"
}
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "h-2"
}
const _hoisted_6 = {
  key: 0,
  class: "absolute top-0 right-0 z-10"
}
const _hoisted_7 = { class: "flex flex-col items-center" }
const _hoisted_8 = { class: "flex flex-row justify-center items-center w-full" }
const _hoisted_9 = {
  ref: "containerRef",
  class: "text-lg mr-2 overflow-hidden whitespace-nowrap"
}
const _hoisted_10 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_11 = { class: "flex flex-row items-center" }
const _hoisted_12 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_13 = { class: "underline text-blue-500" }
const _hoisted_14 = {
  key: 0,
  class: "text-4xl font-semibold mt-4"
}
const _hoisted_15 = {
  key: 1,
  class: "text-4xl font-semibold mt-4"
}
const _hoisted_16 = {
  key: 3,
  class: "mt-4"
}
const _hoisted_17 = { class: "text-5xl" }
const _hoisted_18 = { class: "text-4xl" }
const _hoisted_19 = { class: "flex flex-row items-center" }
const _hoisted_20 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_21 = { class: "flex flex-col items-center ml-4" }
const _hoisted_22 = { class: "text-sm" }
const _hoisted_23 = { class: "text-sm" }
const _hoisted_24 = { class: "flex flex-row mt-2 justify-between" }
const _hoisted_25 = { class: "flex flex-row items-center" }
const _hoisted_26 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_27 = { class: "text-xs ml-1" }
const _hoisted_28 = { class: "flex flex-row items-center" }
const _hoisted_29 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_30 = { class: "text-xs ml-1" }
const _hoisted_31 = { class: "flex flex-row items-center" }
const _hoisted_32 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  id: "body_1",
  width: "100%",
  height: "100%",
  style: {"display":"block","margin":"auto"}
}
const _hoisted_33 = { class: "text-xs" }
const _hoisted_34 = { class: "flex mt-4 justify-center items-center" }
const _hoisted_35 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_36 = {
  key: 1,
  class: "text-sm"
}
const _hoisted_37 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: _ctx.operatorData.operator_status.site_code + '_' + _ctx.operatorData.operator.operator_code,
      style: {"width":"225px"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.operatorData.operator_status.is_break)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[5] || (_cache[5] = _createTextVNode(" 休憩中  ")),
              _createElementVNode("span", {
                textContent: _toDisplayString(_ctx.breakDuration)
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.operatorData.operator_status.is_break)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5))
        : _createCommentVNode("", true),
      _createVNode(_component_el_card, {
        style: _normalizeStyle([{
                    border: _ctx.operatorData.operator_status.is_break ? '10px solid #14b8a6' : '1px solid #d1d5db',
                }, {"border-radius":"0px","box-shadow":"0 0 #0000","position":"relative"}])
      }, {
        default: _withCtx(() => [
          (_ctx.operatorData.operator_status.is_work)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_el_button, {
                  type: "danger",
                  link: "",
                  onClick: _ctx.handleCloseButton
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Close)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  ref: "textRef",
                  class: _normalizeClass({ marquee: _ctx.isOverflowing })
                }, _toDisplayString(_ctx.operatorData.operator.organization_name) + " " + _toDisplayString(_ctx.operatorData.operator.operator_name), 3)
              ], 512),
              (_ctx.operatorData.operator.schema_primary_key === 'telephone')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    link: "",
                    onClick: _ctx.handleUpdateName
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, { size: 16 }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock("svg", _hoisted_10, _cache[6] || (_cache[6] = [
                            _createElementVNode("g", null, [
                              _createElementVNode("image", {
                                x: "0",
                                y: "-1",
                                "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAy1JREFUWEe1ls9rE0EUx9/bGEREqVYRRBARtFZBRAQRrYhKuvMmoSKmBXv33oPX1qMH/wGvKkKrWNLZpEH8gYgI0gZBaxVUBBHEqkURkSY79oXZsI35MUnWOYXs7Hw++327bwYh4iGEOIuIg57npW2WRptJtnOklGe01rcAwAGACRuJyASIKAUAtwFgVUi4qUQkAkIIiYj85KsB4CWngIijRqShRMcCUkphYl/DcN/307lcbk4IMWYj0ZEAESVM7GvD8KAENhJtCwghTpvY19eC20q0JSClPGli77KBa60v1StHywJEdAIRJ7TW3bbwbDY7Vq8cLQkIIfpM7JtbgTcqh7WAlPKoiX1LO/B6ElYCRHSEOxsAbO0E7rpur+M448tr7QUAX2udbirguu5hx3EYvi1CeBER00qpOw0FksnkId/3Gb49QvgfAEh7npfhstQVIKKDJvYdEcJ/c+zZbFYF70RNAdd1D5jYd0YI/2Viz4Z3138EpJT7tdb8ouyKEP7DxJ6v3tpXCBDRPhN7T4TwRRP73VrniopAKpVaVyqVngJAb1RwRPwKAINKqXv1DjUVgWQyedz3/YfBRO7f3ELDNwbttNY1nlf1nX9huOd5DxqdqCoCQogRRLyyfNMrAODDxHgY1CL8s4n9UbPjXEWAiK4DwPnlbnfV87wLRHQukCh/r4ijlk/+iQ+lSqnHzeAr+gAR8ZP3IOKwUuoGXwwk+Lcl/KOJ/YkNvCLQ39+/OxaLzfMfxWKxO5/PfwsWCCdR/U5U1fyD7/tDuVyOX2TrUS4BEQ0BwE0AWPA8j7faFaOWRBX8veM4g1NTU8+syWZiWUAIcRkRL5r/uE9z/68rwY0qtKu9NbHPtAqvlICIuEmcCi3QUIL7hNlS35jYC+3AywIDAwNdS0tL7wBgQ9UiZYlEIrExHo+7Wus+ADgGAHvMvHlEHFJKPW8XXhbgMx4A3K+zyAIAbKpxbc7E/qITeFlASjmiteYG1GjwFzKjtZ6NxWIziDibyWR+dgoPErgGAMOhxb4HMEQslEqlwvT09OsoYLXW4BJwjAWGaa0L8Xi8MDk5ufi/gNXr/gWVaFb7krx7kgAAAABJRU5ErkJggg==",
                                preserveAspectRatio: "none",
                                width: "100%",
                                height: "100%"
                              })
                            ], -1)
                          ])))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_icon, {
                class: "mr-2",
                size: 18
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_12, _cache[7] || (_cache[7] = [
                    _createElementVNode("g", null, [
                      _createElementVNode("image", {
                        x: "0",
                        y: "0",
                        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdRJREFUaEPtWjFOw0AQ3PVLQIIGWugDXc5OSw0NFDyC8AgKaKCmje/SAT200BCJvMQLZ9nIQoLM2joE0qZMZud25m5iybdMPT7OuYKZJ0S0T0QbPSi6JQsiuhORWQih1HKxtsA5N2XmM20dgheR8xDCFMG2GJUA59wOMz9qFtBiRWQ3hPCE1qkE5Hl+TUSHKHlP3I33/git1Qp4I6I1lLwnbum9X0drtQIEJR6C897DfcHA2FCe558CmHlvSJNfa0Xkvv3uVwRoFkGEds3RcPfeAc0iJuAHB2wHkOOBYCwDKV1KyW0ZQNxFMJaBlC6l5LYMIO4iGMtASpdSclsGEHcRjGUgpUspuS0DiLsIxjKQ0qWU3JYBxF0EYxlI6VJKbssA4i6CsQykdCkld+8MENED0pgCM2qxmjffQwQoetNBTcB3fnX/KVZ5Gu98ReQ24pj5QHO3/Cd2IN6hlWVZ56QoilH3DmyV+JQCXtHRgqqqtufz+Utsdjweb2VZ9ryq8eb3hfd+E8SSNsSXRHSMkMcjlGVZvQNVVY0UR+jKe3+CrFEfTxQYcc2Qx0xTo8WKyEQz9KES0Ij4v8MerZvN0Mfpx8MsPnyGjh4s40NRRC40Qx5tL+/RHIFAxURXAwAAAABJRU5ErkJggg==",
                        preserveAspectRatio: "none",
                        width: "100%",
                        height: "100%"
                      })
                    ], -1)
                  ])))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.operatorData.operator.telephone), 1)
            ])
          ]),
          _createVNode(_component_router_link, {
            to: {
                        name: 'OperatorDetail',
                        params: {
                            site_code: _ctx.operatorData.operator_status.site_code,
                            operator_code: _ctx.operatorData.operator.operator_code
                        }}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["flex flex-col justify-between items-center mt-2 h-28", _ctx.getHSIBackgroundColor()])
              }, [
                (!_ctx.operatorData.operator_status.is_work)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, "作業完了"))
                  : (!_ctx.operatorData.is_comm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, "通信不能"))
                    : (_ctx.operatorData.app_status.status !== '0')
                      ? (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: 2,
                          effect: "dark",
                          content: _ctx.operatorData.app_status.info,
                          placement: "top"
                        }, {
                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                            _createElementVNode("span", { class: "text-4xl font-semibold mt-4" }, " 計測不能 ", -1)
                          ])),
                          _: 1
                        }, 8, ["content"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getTemperatureSplitPoint(_ctx.operatorData?.vital_data?.body_temperature)[0]), 1),
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.getTemperatureSplitPoint(_ctx.operatorData?.vital_data?.body_temperature)[1]), 1)
                        ])),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_el_icon, { size: 30 }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[9] || (_cache[9] = [
                        _createElementVNode("g", null, [
                          _createElementVNode("image", {
                            x: "0",
                            y: "0",
                            "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAA/BJREFUaEPtWU2I3VQU/s6LbkYoLpSKrRSti4oiKIo4uLBQlJdzM7yKFUQFXSgiUmhtiz+IdaHSseqiSCkI/lBd+NAOMznJVBd2pbh41C50EFoQqzLiwopQhWdy7B0ymEmTlzBj0hFzl/eem+985++ee0NoeHie14ui6AYiugnAbQBIVQedTudEHMdzRBSKyK9V1aKqgiuV8zzv1jiOJwHcWfKtOVV9PgiCj6pgNkLAGDOpqrurKJSSOSgiT5TtqZ2A67ovE9EzZYoUrB8Qke2j9tZKwPO8TTauCxT4BcDpZO0qAJfnyRHRZt/3jxWRqJUAM/cB3JsDvktEXkvPM/NTAPbnyJ6M43g8DENL+LxRGwFjzFZV/TiLKCIjMZlZc/TcLyK5OVQbAdd19xLRCxll7hMR65XCwczbAHyYFiCiT3zfv7tRDzCztf7WFOgpEbmWma8BcCpPGVV9NAiCt5j5JICNKZmfReSKpglklTgiIve4rruPiPYUuOCYiGzOIQ8i2uD7/vfZfbWFEDP/BmBNCvANEdlpjDmiqr0SAq8D2JGRuUVEBk0S+BTAlhTgFyIyXpAbi2ILJJn5cwC3p5XtdDqXzMzMnG2MgDHmFVV9Og14rufxgiDw8yoNER0fDodbHMcZJ6KZTBIf933/5kZzwBjzgKoezoD+JCLr7FziCXtG/KmqvuM4k9bCzPwjgCsz+/aJyBJjLK7XlgMTExNroyj6EsCGrDWjKNoWhuGSStTtdjc6jtNXVdulLhlRFF09Ozv7XaMesGDMvAvAqznANpaPAvghWVsPwNb5sRzZd0TkkYKkR20eWAR0XfcEEd1YpECV+VH9UO0ErILGmKOqelcVZYtk4jh2wzAMG6tCWaCkNzoIYG0FIrb7PO/iQ0QP+r7//pKcqvCxf03EGLNOVXfY66Sq2rJ4qf24qg6J6GsAAYDDIjLnuu40EXk54NtF5EDtVagK6+S+cNH8/Py3g8FgmN3DzB8AuD87r6p7gyB40c43kgNVyBTJMPMhAI9l1s+OjY1d1u/3/2iUADN/BuBiIpIoir6yp6/jOH+p6iYA16mqPYXfzd7AjDHvqepDaRKO46yZnp7+/UIQGPkqUVQymfltAA8nOfNmEARPNh5CiQeWRSApxwt70x76z3jggp3EaeCVeiCPxLI90Ov1Fmp42ZiamjqzKLOqCDDzSwCeLSFwSEQebwmMsNKyQ6j1QIFVy54Ss9taD7RJnLHAskKo2+12O53Oc2U1XUTuSJXE1VNGEwL2MjFqfHPuYfb6lkDJP7KVhFDrgZz4a6aVaHOgOPVbD5SV9oVWog2hNoT+scD/+hyQkoSZW42txN/j7XhPSt7PDgAAAABJRU5ErkJggg==",
                            preserveAspectRatio: "none",
                            width: "100%",
                            height: "100%"
                          })
                        ], -1)
                      ])))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formattedDate(_ctx.operatorData?.vital_data?.check_timestamp)), 1),
                    _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formattedTime(_ctx.operatorData?.vital_data?.check_timestamp)), 1)
                  ])
                ])
              ], 2)
            ]),
            _: 1
          }, 8, ["to"]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_el_icon, { size: 20 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[10] || (_cache[10] = [
                    _createElementVNode("g", null, [
                      _createElementVNode("image", {
                        x: "0",
                        y: "0",
                        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAgBJREFUWEe9l9FxwjAMhq2DPUonaXjjcHZoMgkwCbBDzPHWdJKySM6gnMWpqa3YDmle4Ejw91u/JCugZro2m81quVxW1toPpVShlLo9Ptuu6w7X6xW/9xfMwS/LsniAv9zaLQB8W2vfnBAFAOemafazCNhutxUAHN1ua75bFpUdABxQxEsjwOHGmHUoumVZ7q21nwBQv0xALBxFYSQWiwVadHuJgBQ4RUVrjQJWkwXkwFGEs2E3SYAP7sJ7xMynTPflgtYaEzU/AgL8xwFvvNy4CCcSnztlRSACTjyvCOd/YYyBZAEJcBJxMsbUg+QrHhatm6ZpkwRkwDECNYJQAO3cWltfLpdTUiecAx4tgCVNSx2O/eZL8tGdJx1GPGmGXnro0fCoCNDJxn3DPzJLuIYkeJQA1zAqLJnhbqmbsboXE87n1WgVaK2xYaD3z1LiC/GTTcr20MkYI8AOwy8NMb5Sk54XBVD4u65754NFaMFUuJgDvF+Hws+F5MBFAbQgtcyR6WaH91OsEvuABPdMu7gWTru/5j/Jd37vTw6E4M4S3GnFyu6McMr+WGhQQAjOx2yaZnNgYh8gOA4JPOkYPDvMo2XI4Pjsc4jgcGnMnhINGLRTWqt/jXJ+P0/AKaBgJ3StdhV4YFZ43wcEAbPDewEBC/4F3gvgL4w8Aefw27fmHWGlvbTC0Dy3AAAAAElFTkSuQmCC",
                        preserveAspectRatio: "none",
                        width: "100%",
                        height: "100%"
                      })
                    ], -1)
                  ])))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.operatorData.operator_status.calera_battery) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_icon, { size: 20 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[11] || (_cache[11] = [
                    _createElementVNode("g", null, [
                      _createElementVNode("image", {
                        x: "0",
                        y: "0",
                        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAzRJREFUWEfFVzGO2zAQJCV1/oSvSJkHpIrdHST9IfZDgtx1eUK6+LrUhmi4i9KkDpA2QJQXpHEXUYyH4BormhTlIMC5MWBpl7Ozw9m1FM/8kc98vogCuL+/XxZFsRRCrIZh6A6Hw24uWIodhmGZZVnXNE0bi70CUNf1yhjzORLQSSmfmqZ5CD2v6/rBGPPultgLAId6E0jQCSHABP90Wuv18XjEM4HYPM8/gi32kn3mx0opH3kBFwBVVaFqStC6Fy11OADfeZ6juo1LbNk4x7QeY1exaKUrjPJ3Sqk75LEAOHU+Qp9OV+1PAsErlFKup/odOkd6CXdKqW1KbC4GjF1akzqccjIQYHAry7LcSCnRP6GUsoyUZfkpy7IPqAaixG/GGGrXN6XUby7WuYczvVjwYFtWVYXD0VdbfV3Xr4wxX6WU70+n09vFYvFHCEG3Yp3n+Yv9fv+DWodviIpEHLshnFWmtxYA0E+IZEt3vSzLl4fD4fucVtBNIGq11nf0Wyx+1IaqqoxVY0JAU2C4jnghsRje9iADqcr957yicztxxdZTORiADgDs/U9dv6mEjkXrC7jvKTaZ7lrJ0ZM53MIAVUMFOE2NWCAjI22Q7iB8ACDvH9lrCATY0lpvuchcMlxh62whMbp3WvIYrrvZ45gSc5GR+Hj7yKRoaHGLxw1xlm6dFL5DVgyzIcN57RzOupwfBO8nkREoMjBijXsLPAYAjTFvSKBgHaMa1/6KAT7LpZQQFAYOnBCDCDvBhoMKidcb6RYwZ3AYhpbaOBrHmHbGmC/0gjffrVNSP88+/gugYsbjawNFMPFhgj6NGPBm+kWQFEQ0M3qR8zJWQ96AdmGeIDcqBjN933dcxKMW+KMWSwetZeTxnN45rseF2vf9zrfpKw1wm0SFfPNhIiMVW1VPeP5ovQsZVPAa+iD8PRDPsyxbTk0+f7eMuWPUB1wCjGpaOnZa68fUpAvsh3bxiG1Kk0bkkl3tgaHKI0tt0l1nOWFg3baDB6JC/4ui8LfpyfWda2YWAFqlQgel1u7UYJsNgBLFqJ76wzIF4mYAHEiWZavUbfjvDKQS3vr8nxm49aDY+38Bjj2QC3gkljgAAAAASUVORK5CYII=",
                        preserveAspectRatio: "none",
                        width: "100%",
                        height: "100%"
                      })
                    ], -1)
                  ])))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.operatorData.operator_status.hrm_battery) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_el_icon, { size: 20 }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock("svg", _hoisted_32, _cache[12] || (_cache[12] = [
                    _createElementVNode("g", null, [
                      _createElementVNode("image", {
                        x: "0",
                        y: "0",
                        "xlink:href": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAdRJREFUaEPtWjFOw0AQ3PVLQIIGWugDXc5OSw0NFDyC8AgKaKCmje/SAT200BCJvMQLZ9nIQoLM2joE0qZMZud25m5iybdMPT7OuYKZJ0S0T0QbPSi6JQsiuhORWQih1HKxtsA5N2XmM20dgheR8xDCFMG2GJUA59wOMz9qFtBiRWQ3hPCE1qkE5Hl+TUSHKHlP3I33/git1Qp4I6I1lLwnbum9X0drtQIEJR6C897DfcHA2FCe558CmHlvSJNfa0Xkvv3uVwRoFkGEds3RcPfeAc0iJuAHB2wHkOOBYCwDKV1KyW0ZQNxFMJaBlC6l5LYMIO4iGMtASpdSclsGEHcRjGUgpUspuS0DiLsIxjKQ0qWU3JYBxF0EYxlI6VJKbssA4i6CsQykdCkld+8MENED0pgCM2qxmjffQwQoetNBTcB3fnX/KVZ5Gu98ReQ24pj5QHO3/Cd2IN6hlWVZ56QoilH3DmyV+JQCXtHRgqqqtufz+Utsdjweb2VZ9ryq8eb3hfd+E8SSNsSXRHSMkMcjlGVZvQNVVY0UR+jKe3+CrFEfTxQYcc2Qx0xTo8WKyEQz9KES0Ij4v8MerZvN0Mfpx8MsPnyGjh4s40NRRC40Qx5tL+/RHIFAxURXAwAAAABJRU5ErkJggg==",
                        preserveAspectRatio: "none",
                        width: "100%",
                        height: "100%"
                      })
                    ], -1)
                  ])))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.operatorData.operator_status.phone_battery) + "%", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            (_ctx.operatorData.operator_status.is_work)
              ? (_openBlock(), _createElementBlock("span", _hoisted_35, " 作業終了予定  " + _toDisplayString(_ctx.formatTimeRange(_ctx.operatorData.operator_status.planned_end_time, _ctx.operatorData.server_time)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_36, " 終了時刻  " + _toDisplayString(_ctx.formattedDateTime(_ctx.operatorData?.operator_status?.work_end_time)), 1))
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ], 8, _hoisted_1),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: "氏名変更",
      width: "600px",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createVNode(_component_el_button, {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleUpdateNameSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode("確認")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "auto",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "作業員名",
              prop: "operator_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.operator_name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.operator_name) = $event)),
                  placeholder: "作業員名を入力"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}